export default {
  name: 'TransitMixin',
  computed: {
    isCar() {
      return this.transit.type === 'car';
    },
    isContainer() {
      return this.transit.type === 'container';
    },
    isParcel() {
      return this.transit.type === 'parcel';
    },
    departureAtHome() {
      return this.transit.departure.supported === 'home'
    },
    departureAtHarbor() {
      return this.transit.departure.supported === 'harbor'
    },
    reply () {
      return this.transit.replySelected
    }
  },
  methods: {
    country (id) {
      if(id){
        let translation = this.$t('countries').find(c => c.id === id.toUpperCase())
        return translation && translation.name ? translation.name.toUpperCase() : id.toUpperCase()
      } else {
        return null;
      }
    }
  }
}